<!-- Convenios Principal -->
<div>

  <div class="grid">
    <div class="col-12">
      <h1 class="titulo-pagina">{{ 'PERFILRIESGO.LBL_CAMBIOPERFIL' | translate}}</h1>
    </div>
  </div>

  <div>

    <!-- Listado -->

    <div class="grid col-nopad">

      <div class="col-12 md:col-6 md:col-offset-6 lg:col-6 md:col-offset-6" style="display: inline-flex">
        <input type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
               buscador
               [(ngModel)]="busqueda" (change)="setSearch();" (keyup.enter)="filterEnter()">
        <button type="button" icon="fa fa-search" class="p-button p-button-success btn" data-toggle="tooltip"
                title="{{'BTN_BUSCAR' | translate}}" style="margin-top: 7px"
                pButton (click)="filter()"></button>

      </div>


    </div>


    <!-- Tabla -->
    <div class="grid col-nopad">
      <div class="col-12 md:col-12 lg:col-12">
        <p-table [columns]="columnas"
                 [loading]="cargandoTabla" #td
                 [rows]="rowsCount"
                 [value]="datosTabla"
                 [paginator]="true"
                 [lazy]="true"
                 [totalRecords]="rowsCount"
                 (onLazyLoad)="filter($event)"
                  paginatorPosition="bottom"
                  selectionMode="single">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                  class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.numeroDocumento }}</td>
              <td>{{row.primerNombre + ' ' + (row.segundoNombre ? row.segundoNombre : '')}}</td>
              <td>{{row.primerApellido + ' ' + (row.segundoApellido ? row.segundoApellido : '')}}</td>
              <td>{{row.nombreRiesgo}}</td>
              <td class="text-center">
                <div class="btn-group" role="group">
                  <button type="button" class="p-button btn" icon="fa fa-users" data-toggle="tooltip"
                          title="{{'BTN_CAMBIARPERFIL' | translate}}"
                          pButton (click)="editar(row)"></button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>


  </div>


</div>
